module.exports = function(video) {
  "use strict";
	video
    .controller('relatedVideoBoxController', relatedVideoBoxController)

	relatedVideoBoxController.$inject = ["config","durationFormated","$http", "$rootScope","$scope","getDataService","$state", "$stateParams","refreshtokenService","reqursiveService","putDataService","alertService","$timeout","postDataService","deleteDataService","serverError", "API_URL","offlineError"];
	
  function relatedVideoBoxController(config,durationFormated,$http,$rootScope,$scope,getDataService,$state, $stateParams,refreshtokenService, reqursiveService, putDataService, alertService, $timeout, postDataService,deleteDataService,serverError, API_URL, offlineError) {
    var vmrvb = this;
    var state = 'video';
    vmrvb.config = config;
    vmrvb.allWidgets= [];
    vmrvb.minimumItem ={
      ids:{       
      },
      number:2
    }
    vmrvb.duplicateVideo = {
      ids:{

      }
    }
    vmrvb.durationFormated = durationFormated;
    vmrvb.addVideo = function(type) {
      $rootScope.modalShow = true;
      vmrvb.videoModalShow = true;
      vmrvb.addCategory = type;
    }
    vmrvb.cancelVideoModal = function() {
      $rootScope.modalShow = false;
      vmrvb.videoModalShow = false;
      vmrvb.addCategory = null;
    }
    vmrvb.thumbConvert = function(image) {
      if(!image) return
      return vmrvb.config.baseVideoHref + image.replace('.jpg','-254x191.jpg')
    }
    vmrvb.removeVideoFromWidget = function(categoryId,videoId) {
      for (var i=0; i<vmrvb.allWidgets.length; i++) {
        vmrvb.minimumItem.ids[vmrvb.allWidgets[i].category_id] = false;
        if(vmrvb.allWidgets[i].category_id == categoryId) {
          for (var j=0; j<vmrvb.allWidgets[i].videos.length;j++) {
            if(vmrvb.allWidgets[i].videos[j].video_obj._id == videoId) {
              if(vmrvb.allWidgets[i].videos.length<=2) {
                vmrvb.minimumItem.ids[vmrvb.allWidgets[i].category_id] = true;
                $timeout(function() {
                  resetErrors(vmrvb.minimumItem)
                },3000)
              } else {
                vmrvb.allWidgets[i].videos.splice(j,1)
              }
              break
            }
          }
          break
        }
      }
    }
    function resetErrors (obj) {
      for (var i=0; i<vmrvb.allWidgets.length; i++) {
        $scope.$apply(function() {
          obj.ids[vmrvb.allWidgets[i].category_id] = false;
        })
      }
    }  
    vmrvb.setVideoFunction = function(videoObj, category) {
      if(!videoObj) return;
      for (var i=0; i<vmrvb.allWidgets.length; i++) {
        vmrvb.duplicateVideo.ids[vmrvb.allWidgets[i].category_id] = false;
        if(vmrvb.allWidgets[i].category_id == category) {
          vmrvb.minimumItem.ids[category] = false;
          for (var j=0; j<vmrvb.allWidgets[i].videos.length;j++) {
            if(videoObj._id == vmrvb.allWidgets[i].videos[j].video_obj._id) {
              vmrvb.duplicateVideo.ids[vmrvb.allWidgets[i].category_id] = true;
              $timeout(function() {
                resetErrors(vmrvb.duplicateVideo)
              },3000)
              return 
            }
          }
          vmrvb.allWidgets[i].videos.push({
           'video_obj': videoObj,
           'category_id': videoObj.category._id
          })
          break;
        }
      }
    }
    vmrvb.saveChanges = function() {
      $rootScope.hasLoaded = false;
      var videoIds = [];
      for (var i=0; i<vmrvb.allWidgets.length; i++) {
        for (var j=0; j<vmrvb.allWidgets[i].videos.length;j++) {
          videoIds.push({
            _id: vmrvb.allWidgets[i].videos[j]._id,
            category_id: vmrvb.allWidgets[i].category_id,
            order: vmrvb.allWidgets[i].videos[j].order,
            video_id: vmrvb.allWidgets[i].videos[j].video_obj._id
          })
          // if(j==vmrvb.minimumItem.number - 1 ) break;
        }
      }
      var postFunction = function() {
        postDataService.save({
          param1:state, 
          param2: 'related', 
        },{
          'related': videoIds
        }).$promise.then(function(data){
          $rootScope.hasLoaded = true;
          alertService('success','Success ', data.message, 2000);
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
            function(answer) {
              if(answer==200) {
                postFunction();
              }
              // do something
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
            });
          }else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        });
      }
      postFunction();
    }
    var getFunction = function() { 
      getDataService.get({
        param1: state,
        param2: 'related'   
      }).$promise.then(function(data){
        vmrvb.allWidgets = data.related;
      },function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {   
                getFunction();
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
          });
        }else if(error.status ==502) {
          serverError()
        }else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }  
      });
    }
    getFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  } 
}
  


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/related-video-box/js/relatedVideoBoxController.js
// module id = 648
// module chunks = 0